import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { AuthContext } from '../../../../auth-context'
import Input from '../../../../components/input'
import Button from '../../../../components/button'
import { retrievePortalEzfacilityAccessToken, revokePortalEzfacilityAccess } from '../../../../api'
import SettingsEthernet from '@material-ui/icons/SettingsEthernet'

const EzfacilityContainer = styled.div`
background: #FFF;
border-radius: 8px;
box-shadow: 0px 0px 8px 0px #e1e2e6;
width: 100%;
padding: 24px;

@media(max-width: 900px) {
  padding: 16px;
}
`

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`
const ButtonContainer = styled.div`
background: #FFF;
width: 100%;
`

const Ezfacility = () => {
  const [busy, setBusy] = useState(false)
  const [connecting, setConnecting] = useState(false)
  const [message, setMessage] = useState('')
  const [usernameError, setUsernameError] = useState(false)
  const [passwordError, setPasswordError] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const { user, updateUser } = useContext(AuthContext)

  const startConnecting = () => {
    setConnecting(true)
  }

  const stopConnecting = () => {
    setConnecting(false)
    setMessage('')
    setUsernameError(false)
    setPasswordError(false)
    setUsername('')
    setPassword('')
  }

  const connectToEzfacility = () => {
    if (!username) {
      setUsernameError(true)
    } else if (!password) {
      setPasswordError(true)
    } else {
      setBusy(true)
      retrievePortalEzfacilityAccessToken(user.id, username, password).then((res) => {
        setBusy(false)
        if ('error' in res.data) {
          setMessage(res.data.error)
          setUsernameError(true)
          setPasswordError(true)
        } else {
          setConnecting(false)
          setMessage('')
          setUsernameError(false)
          setPasswordError(false)
          setUsername('')
          setPassword('')
          updateUser(Object.assign({}, user, { ezfacility_connected: true }))
        }
      })
    }
  }

  const disconnectFromEzfacility = () => {
    setBusy(true)
    revokePortalEzfacilityAccess(user.id).then((res) => {
      setBusy(false)
      updateUser(Object.assign({}, user, { ezfacility_connected: false }))
    })
  }

  return (
    <EzfacilityContainer>
      <Label>
        <SettingsEthernet /> EZFacility Connection
      </Label>
      {user.ezfacility_connected ? (
        <ButtonContainer>
          <p>You are connected to EZFacility.</p>
          <Button 
            label="Disconnect from EZFacility"
            isLoading={busy}
            disabled={busy}
            onClick={disconnectFromEzfacility}
          />
        </ButtonContainer>
      ) : (connecting ? (
        <ButtonContainer>
          {message && (
            <p>{message}</p>
          )}
          <Input
            error={usernameError}
            label="Username" 
            value={username}
            onChange={setUsername}
          />
          <Input
            error={passwordError}
            label="Password"
            type="password"
            value={password}
            onChange={setPassword}
          />
          <Button 
            label="Sign in to EZFacility"
            isLoading={busy}
            disabled={busy}
            onClick={connectToEzfacility}
          />
          <Button 
            label="Cancel"
            isLoading={busy}
            disabled={busy}
            onClick={stopConnecting}
          />
        </ButtonContainer>
      ) : (
        <ButtonContainer>
          <p>You are not connected to EZFacility.</p>
          <Button 
            label="Connect to EZFacility"
            isLoading={busy}
            disabled={busy}
            onClick={startConnecting}
          />
        </ButtonContainer>
      ))}
    </EzfacilityContainer>
  )
}

export default Ezfacility
